import withBreakpointObserver from '@studiometa/js-toolkit/decorators/withBreakpointObserver';
import gsap from 'gsap';
import random from 'canvas-sketch-util/random';
import Canvas from './Canvas.js';

/**
 * CanvasMenu class
 */
export default class CanvasMenu extends withBreakpointObserver(Canvas) {
  /**
   * Config
   */
  get config() {
    return {
      name: 'CanvasMenu',
      options: {
        inactiveBreakpoints: {
          type: String,
          default: 'xxs xs s',
        },
      },
    };
  }

  /**
   * Init
   */
  init() {
    // Canvas size
    this.width = 256;
    this.height = 192;

    super.init();
  }

  /**
   * Resized hook
   */
  resized() {
    // Silence
  }

  /**
   * No after load animation
   */
  afterLoadAnimation() {
    // Silence.
  }

  /**
   * Set the spirte size
   */
  setSpriteSize(sprite) {
    sprite.anchor.set(0.5);
    sprite.position.x = this.width / 2;
    sprite.position.y = this.height / 2;
  }

  /**
   * Change slide animation
   */
  changeSlideAnimation(newIndex) {
    // Get Random Values for the displacementSprite
    // in order to have unique animations at each change
    const randomX = random.range(-200, 200);
    const randomY = random.range(-200, 200);

    // Set distorsion
    gsap.set(this.displacementFilter.scale, { x: 100, y: 100 });
    gsap.set(this.displacementSprite, { x: randomX, y: randomY });

    // Fade in the sprite image
    gsap.to(this.sprites[newIndex], { alpha: 1, ease: 'sine.out' }, 0.1);

    // Create a Timeline for the animation
    const tl = gsap.timeline();

    // Reset the distortions
    tl.to(this.displacementFilter.scale, { x: 0, y: 0, duration: 0.8, ease: 'sine.in' }, 0.2);
    tl.to(this.displacementSprite, { x: 0, y: 0, duration: 0.8, ease: 'sine.in' }, 0.2);

    // Fade out all slides
    this.sprites.forEach((sprite, spriteIndex) => {
      if (spriteIndex !== newIndex) {
        tl.to(sprite, 0.3, { alpha: 0, ease: 'power3.out' }, 0);
      }
    });

    this.index = newIndex;
  }
}
